import React, { Component } from "react";
import PropTypes from "prop-types";
import MetaTags from 'react-meta-tags';
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { AvField, AvForm} from "availity-reactstrap-validation";
import "../../pages.scss";
import { getResponse } from "../../../helpers/api_helper";
import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

class Base64Encode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputText: "",
      buttonTimer: false,
      respData: [],
      respErrorData: [],
      items: [],
      histjson: [],
    }
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.addFailItem = this.addFailItem.bind(this);
    this.addSuccessItem = this.addSuccessItem.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleValidSubmit = (event) => {
    event.preventDefault();
    this.setState({ buttonTimer: true });

    const { inputText } = this.state;
    const cloudInput = { data: inputText };

    getResponse(cloudInput, "/cloud/v1/Base64/Encode")
      .then((resp) => {
        this.setState({ buttonTimer: false });

        if (resp.resultCode !== "-1" && resp.resultCode !== undefined) {
          this.setState({ respData: [resp.resultData] });
          const dnm = JSON.parse(localStorage.getItem("jsonHistory"));

          if (dnm != null && dnm != 0) {
            this.setState({ histjson: JSON.parse(localStorage.getItem("jsonHistory")) });
            const a = [...this.state.histjson];
            a.push(resp);
            localStorage.setItem("jsonHistory", JSON.stringify(a));
          }
          else {
            localStorage.setItem("jsonHistory", JSON.stringify([resp]));
          }

          this.addSuccessItem();
        }
        else {
          this.setState({ respErrorData: [resp.resultDesc] });
          const dnm = JSON.parse(localStorage.getItem("jsonHistory"));

          if (dnm != null && dnm != 0) {
            this.setState({ histjson: JSON.parse(localStorage.getItem("jsonHistory")) });
            const a = [...this.state.histjson];
            a.push(resp);
            localStorage.setItem("jsonHistory", JSON.stringify(a));
          }
          else {
            localStorage.setItem("jsonHistory", JSON.stringify([resp]));
          }
          this.addFailItem();
        }
      })
  }
  addSuccessItem = () => {
    this.setState({ items: [] });

    this.setState(prevState => ({
      items: [
        ...prevState.items,
        <Col key={Date.now()} >
          <Card>
            <CardBody>
              <Alert className="alert-success" role="alert">
                <h4 className="alert-heading">{this.props.t("Base64EncodeSearchOperationSuccess")}</h4>
                <hr />
                <div className="display-linebreak">{this.state.respData}</div>
              </Alert>
            </CardBody>
          </Card>
        </Col>
      ]
    }));
  }

  addFailItem = () => {
    this.setState({ items: [] });
    this.setState(prevState => ({
      items: [
        ...prevState.items,
        <Col key={Date.now()} >
          <Card>
            <CardBody>
              <Alert className="alert-danger" role="alert">
                <h4 className="alert-heading">{this.props.t("Base64EncodeSearchOperationFail")}</h4>
                <hr />
                <div className="display-linebreak">{this.state.respErrorData}</div>
              </Alert>
            </CardBody>
          </Card>
        </Col>
      ]
    }));
  };
  handleInputChange = (event) => {
    this.setState({ inputText: event.target.value });
  };

  handleClear = () => {
    this.setState({ inputText: "", respData: [], respErrorData: [] });
  };
  
  render() {
    const { inputText } = this.state;
    const defaultValues = { searchOption: "0" }
    return (
      <React.Fragment>
        <div className="page-content">
          <Helmet>
            <MetaTags>
              <title>Wechip - Wechip Payment Tools | {this.props.t("Base64E")}</title>
              <meta name="description" content="Base64 Encode refers to encoding text or data into Base64 format. Explore the principles and techniques behind Base64 encoding, its applications, and its significance in data transmission." />
              <meta name="keywords" content="Base64 encode, data encoding, secure data transmission, Base64 format" />
            </MetaTags>
          </Helmet>
          <Container fluid>
            <Breadcrumbs title={this.props.t("Base64")} breadcrumbItem={this.props.t("Base64Encode")} />
            <Row>
              <Col md={6}>
                <Card>
                  <CardBody>
                    <AvForm onValidSubmit={this.handleValidSubmit} model={defaultValues}>
                      <Row className="rowAes">
                        <Col className="mb-3">
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label htmlFor="inputText">{this.props.t("inputText")}</Label>
                            <UncontrolledTooltip placement="bottom" target="inputText">
                              {this.props.t("inputTextInfo")}
                            </UncontrolledTooltip>
                            <AvField
                              name="inputText"
                              placeholder={this.props.t("fill")}
                              type="text"
                              value={inputText}
                              onChange={this.handleInputChange}
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="d-flex flex-wrap gap-2" style={{ paddingTop: 6 }}>
                        <Button
                          color="secondary"
                          onClick={() => window.location.reload()}
                          style={{ textAlign: "start" }}
                          className="buttonEncode"
                        >
                          {this.props.t("clearButton")}
                        </Button>
                        <Button
                          type="submit"
                          disabled={this.state.buttonTimer}
                          color="primary"
                        >

                          {this.props.t("Encode")}
                        </Button>
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
              <Col xs="6" >
                <Card className="scroll-col">
                  {this.state.items.slice().reverse()}
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Base64Encode.propTypes = {
  t: PropTypes.any,
};

export default (withTranslation()(Base64Encode));